import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { getHandbooksAllSegments } from "../model/thunks";
import { useTypedSelector } from "app/store/typedUseSelector";

export const useHandbookSegments = () => {
  const dispatch = useDispatch();
  const invalidationKey = useTypedSelector((state) => state.handBookReducer.invalidationKey);

  const allSegments = useTypedSelector((state) => state.handBookReducer.allSegments);

  useEffect(() => {
    dispatch(getHandbooksAllSegments());
  }, [invalidationKey]);

  return allSegments;
};
